<script>
    export let data, counties;
    import { selCounty, selSystem } from '../store.js';

    let systemList = data;

    $: if ($selCounty) {
        systemList = data.filter(function(d){ return d.county == $selCounty; });
       }
</script>

<select name="county-selector" id="county-selector" aria-label="Select a county from the dropdown to filter" tabindex=“0”>
    <option value="" disabled selected hidden>Filter by county</option>
    {#each counties as county}
    {#if $selCounty == county }
        <option value="{county}" aria-label="{county}" selected>{county}</option>
    {:else}
        <option value="{county}" aria-label="{county}">{county}</option>
    {/if}
    {/each}
</select>

<select name="system-selector" id="system-selector" class="disabled" aria-label="Select a system from the dropdown to filter">
    <option value="" disabled selected hidden>Select a water provider</option>
    {#if $selCounty}
        {#each systemList as system}
            {#if $selSystem == system.pwsid }
                <option value="{system.pwsid}" aria-label="{system.pwsid}" selected>{system.system_name}</option>
            {:else}
                <option value="{system.pwsid}" aria-label="{system.pwsid}">{system.system_name}</option>
            {/if}
        {/each}
    {/if}
</select>